module.exports = "/_next/static/images/f4bf9261142d9bb4b20d43f88de326fa-woman-with-yellow-glasses@0.5x.jpg";